import {Action, Actions} from './actions';

export type State = {
	disabled: boolean;
	clickKeysDisabled: boolean;
	keysDisabled: boolean;
	activeIndex: number;
	total: number;
	pageSize: number;
	returnToIndexOnFocus: number;
	userDisabled: boolean;
};

export const getInitialState = (props: Partial<State>): State => {
	return {
		clickKeysDisabled: false,
		disabled: true,
		userDisabled: false,
		activeIndex: 0,
		keysDisabled: false,
		pageSize: 25,
		returnToIndexOnFocus: -1,
		total: 0,
		...props,
	};
};

const checkIndexLoop = (index: number, total: number) =>
	index > total - 1 ? 0 : index < 0 ? total - 1 : index;

const keepInBounds = (index: number, total: number) =>
	Math.max(Math.min(index, total - 1), 0);

export const reducer = (state: State, action: Actions): State => {
	switch (action.type) {
		case Action.Disable:
			return {
				...state,
				disabled: true,
			};

		case Action.DisableClickKeys:
			return {
				...state,
				clickKeysDisabled: true,
			};

		case Action.DisableKeys:
			return {
				...state,
				keysDisabled: true,
			};

		case Action.Enable:
			return {
				...state,
				disabled: false,
			};

		case Action.EnableClickKeys:
			return {
				...state,
				clickKeysDisabled: false,
			};

		case Action.EnableKeys:
			return {
				...state,
				keysDisabled: false,
			};

		case Action.End:
			return {
				...state,
				activeIndex: keepInBounds(state.total - 1, state.total),
			};

		case Action.Home:
			return {
				...state,
				activeIndex: 0,
			};

		case Action.NextItem:
			return {
				...state,
				activeIndex: checkIndexLoop(state.activeIndex + 1, state.total),
			};

		case Action.NextPage:
			return {
				...state,
				activeIndex: keepInBounds(
					state.activeIndex + state.pageSize,
					state.total,
				),
			};

		case Action.PrevItem:
			return {
				...state,
				activeIndex: checkIndexLoop(state.activeIndex - 1, state.total),
			};

		case Action.PrevPage:
			return {
				...state,
				activeIndex: keepInBounds(
					state.activeIndex - state.pageSize,
					state.total,
				),
			};

		case Action.SetActiveItem:
			return {
				...state,
				activeIndex: keepInBounds(action.index, state.total),
			};

		case Action.SetPageSize:
			return {
				...state,
				pageSize: action.pageSize || 25,
			};

		case Action.SetReturnToIndexOnFocus:
			return {
				...state,
				returnToIndexOnFocus: action.index,
			};

		case Action.SetTotal:
			return {
				...state,
				total: action.total,
				activeIndex: keepInBounds(state.activeIndex, action.total),
			};

		case Action.UserDisable:
			return {
				...state,
				userDisabled: true,
			};

		case Action.UserEnable:
			return {
				...state,
				userDisabled: false,
			};

		default:
			return state;
	}
};

export default reducer;
